<template>
    <div>
        <!--  Header Section Start  -->
		<div class="header-section">
			<div class="info-area">
				<div class="container">
					<div class="row">
						<div class="col-md-6 col-sm-5">
							<ul class="socials">
								<!-- <li><a href="#"><i class="fab fa-facebook-f"></i></a></li> -->
								<li><a href="https://www.instagram.com/tamir__hane/"><i class="fab fa-instagram"></i> Bizi Takip Edin</a></li>
								<!-- <li><a href="#"><i class="fab fa-twitter"></i></a></li> -->
							</ul>
						</div>
						<div class="col-md-6 col-sm-7 d-none d-sm-block">
							<p class="mb-0 text-right">Pazartesi - Cumartesi 08:00 - 18:00</p>
						</div>
					</div>
				</div>
			</div>
			<div class="support-area">
				<div class="container">
					<div class="row align-items-center">
						<div class="col-lg-8 col-xl-6">
							<div class="row">
								<div class="col-lg-7">
									<div class="support-box">
										<div class="icon-wrapper"><i class="flaticon-facebook-placeholder-for-locate-places-on-maps"></i></div>
										<div class="support-txt">
											<h4>Neredeyiz ?</h4>
											<p>İsmet Paşa Mahallesi Küçük Sanayi Sitesi 21. Sokak No: 20 Merkez Çanakkale</p>
										</div>
									</div>
								</div>
								<div class="col-lg-5">
									<div class="support-box">
										<div class="icon-wrapper"><i class="flaticon-envelope"></i></div>
										<div class="support-txt">
											<h4>Bize Ulaşın</h4>
											<p>
												0 (532) 453 60 25
												<br />
												0 (542) 499 60 25
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-lg-4 col-xl-6">
							<div class="appointment">
								<p>Acil Servis Hattı</p>
								<a class="phone-number" href="tel:+905324536025">
									<div class="icon-wrapper"><i class="flaticon-phone-receiver"></i></div>
									<span>0 (532) 453 60 25</span>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--  Navbar Area Start  -->
			<div class="nav-area">
				<div class="container">
					<div class="main-menu">
						<div class="row align-items-center">
							<div class="col-lg-3 col-6">
								<a class="logo-wrapper" href="/">
									<img v-if="!isMobile()" src="/assets/img/logo-3.png" style="width: 215px; position: absolute; top: -75px; left: -65px" alt="">
									<img v-if="isMobile()" src="/assets/img/logo-3.png" style="min-width: 100px; min-height: 100px; position: absolute; top: -49px; left: 0px; z-index: 99;" alt="">
								</a>
							</div>
							<div class="col-lg-9 col-6 position-static">
								<nav>
									<ul class="menus" id="mainMenu">
										<li><a href="/" class="parent-link">AnaSayfa</a></li>
										<!-- <li><a href="/about" class="parent-link">Servis </a></li> -->
										<li><a href="/contact" class="parent-link">İletişim </a></li>
									</ul>
									<div id="mobileMenu"></div>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--  Navbar Area End  -->         
		</div>
		<!--  Header Section End  -->

    </div>
</template>

<script>
export default {
	methods: {
		isMobile() {
			return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? true : false;
		}
	}
}
</script>
